// src/components/dev/Styled/BackButton.tsx
import React from "react";
import { Affix, Button } from "antd";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet-async";

// Styled component for the container
const StyledButtonContainer = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  position: absolute;

  // Animation from BackButton.css
  animation: fadeIn 1.5s ease-in;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

// Styled component for the Button (optional, if you want to move all styles here)
const StyledBackButton = styled(Button)`
  background: #7acffd; /* SunLight Civilization blue */
  color: #0427f4; /* OLSME blue text */
  border-radius: 8px;
  border: none;

  &:hover,
  &:focus {
    background: #5ab8eb; /* Slightly darker on hover/focus */
    color: #0427f4;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const BackButton: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Go back one step in history
  };

  return (
    <>
      <Helmet>
        <title>Back Button - One Light System OLS</title>
        <meta
          name="description"
          content="Navigate back in One Light System OLS Sun Light Meditation education."
        />
        <meta
          name="keywords"
          content="OLS Back Button, Sun Light Meditation, OLS Navigation, Light Civilization"
        />
        <link rel="canonical" href="https://www.olsme.com/back-button" />
        <meta property="og:title" content="Back Button - One Light System OLS" />
        <meta
          property="og:description"
          content="Navigate back in One Light System OLS Sun Light Meditation education."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>
      <StyledButtonContainer>
        <Affix offsetTop={0} style={{ marginLeft: "64px" }}>
          <StyledBackButton
            shape="circle"
            icon={<LeftOutlined />}
            onClick={handleBack}
            aria-label="Go back to previous page"
          />
        </Affix>
      </StyledButtonContainer>
    </>
  );
};

export default BackButton;